module.exports = __webpack_public_path__ + "static/media/AgreeFisheries28.f30e58bd.jpg";